import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';

const routes: Routes = [
  {
    path: 'detail-view',
    loadChildren: () =>
      import('./modules/detail-view/detail-view.module').then(
        (m) => m.DetailViewModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'events-dashboard',
    loadChildren: () =>
      import('./modules/events/events.module').then((m) => m.EventsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'maps',
    loadChildren: () => import('./modules/google-maps/google-maps.module').then(m => m.GoogleMapsModule)  
  },
  {
    path: 'filter',
    loadChildren: () => import('./modules/filter/filter.module').then(m => m.FilterModule)  
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard],
  },
  { 
    path: 'fleetDetails', 
    loadChildren: () => import('./modules/fleet-details/fleet-details.module').then(m => m.FleetDetailsModule) 
  },
  { 
    path: 'eventsDetails', 
    loadChildren: () => import('./modules/event-details/event-details.module').then(m => m.EventDetailsModule) 
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  { path: 'event-details', loadChildren: () => import('./modules/event-details/event-details.module').then(m => m.EventDetailsModule) },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash : true})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
